import { useIntl } from 'react-intl';

import { SelectOptionType } from '@/shared/config';
import { getLanguageDisplayName } from '@/shared/lib';

import { useTranscriptorLanguages } from './useTranscriptorLanguages';

// A stored code outside the platform list (legacy value, or the list still
// loading) is kept as the first option so the select never shows an empty value.
export const useContentLanguageOptions = (selected?: string) => {
  const { locale } = useIntl();
  const { languageOptions } = useTranscriptorLanguages();

  const isSelectedKnown =
    !selected || languageOptions.some((option) => option.value === selected);

  const options: SelectOptionType[] = isSelectedKnown
    ? languageOptions
    : [
        { value: selected, label: getLanguageDisplayName(selected, locale) },
        ...languageOptions,
      ];

  const getLabel = (code: string): string =>
    languageOptions.find((option) => option.value === code)?.label ??
    getLanguageDisplayName(code, locale);

  return { options, getLabel };
};
